module.exports = __webpack_public_path__ + "img/18.2dd83ab6.webp";